export const NEW_QUESTION_PREFIX = "question";

export const NEW_QUESTION_CHOICE_PREFIX = "question-choice";
